import {Injectable} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {LocalStorageService} from "../../../../../shared/local-storage.service";
import {CreatedNidaResponse, NIdaResponseModel, PayloadNidaData} from "../Models/Nida.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SipaService {

  private base_url = environment.sipaBackendUrl;

  constructor(private http: HttpClient, public localStorage: LocalStorageService) {
  }

  postWithImage(data) {
    return this.http.post<any>(`${this.base_url}/sipa/student/save-photo/`, data)
  }

  loadBenefData(username) {
    return this.http.get<any>(`${this.base_url}/sipa/student/benef-info/?username=${username}`)
  }

  loadBenefPhotoData(username) {
    return this.http.get<any>(`${this.base_url}/sipa/student/benef-photo/?username=${username}`)
  }

  validateNidaNo(payload: any): Observable<NIdaResponseModel> {
    return this.http.post<NIdaResponseModel>(`${this.base_url}/sipa/student/nin-validation/`, payload)
  }

  fetchConfirmNidaDetails(indexno: string) {
    return this.http.get<CreatedNidaResponse>(`${this.base_url}/sipa/student/nin-details/?indexno=${indexno}`,)

  }

  confirmNidaDetails(payload: any): Observable<CreatedNidaResponse>{
    return this.http.post<CreatedNidaResponse>(`${this.base_url}/sipa/student/nin-confirmation/`, payload)
  }
}
